import React, { useState, useEffect } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { MDBDataTable } from "mdbreact";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Skeleton from "@material-ui/lab/Skeleton";
import TableColumnDropdown from "../../../components/shared/table-column-dropdown/table-column-dropdown";

import PersonIcon from "@material-ui/icons/Person";
import swal from "sweetalert";
import ExcelWorkBook from "../../../components/shared/ExcelWorkBook";
import exportFromJSON from "export-from-json";

import { Lock } from "@material-ui/icons";
import { columnasGeneradorContrasenas } from "../../../shared/data/columnas/classics/generador-contrasenas";
import { generatePasswords } from "../../../shared/utils/generatePassword";
import { toast } from "react-hot-toast";

const PasswordGenerator = () => {
  const [passwords, setPasswords] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    updatePasswords();
    let columnas = columnasGeneradorContrasenas;
    setColumns(columnas);
  }, []);

  const updatePasswords = () =>
    setPasswords(
      generatePasswords(50).map((password) => ({
        password,
      }))
    );

  //Funcion para cambiar el estado de visibilidad de una columna
  const changeColumnStatus = (columnField) => {
    const temp = [...columns];
    const index = temp.findIndex((column) => column.field === columnField);
    temp[index].isVisible = !temp[index].isVisible;
    setColumns(temp);
  };

  if (!passwords.length)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <Lock />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Generador de Contrase&ntilde;as</div>
      </div>

      <Container fluid>
        <Row>
          <Col
            xs={12}
            className="content-white-box px-4 py-4"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1
              style={{
                cursor: "pointer",
                margin: "0px",
                textShadow: "0 0 0.3em #66c",
                padding: "0px",
              }}
              onClick={() => {
                navigator.clipboard
                  .writeText(passwords[0].password.slice(0, 6))
                  .then(() => {
                    toast.success("Se ha copiado la contraseña!");
                    //move first password to the end
                    setPasswords(
                      passwords.concat(passwords.splice(0, 1)).slice()
                    );
                  });
              }}
            >
              {passwords[0].password}
            </h1>
          </Col>

          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <PersonIcon />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                Tabla de usuarios Academia
              </div>
            </div>
            <div className="admin-muted-text-small mt-1 mb-4">
              Lista de todos los clientes.
            </div>

            {/* Este componente es el dropdown que permite ocultar columnas*/}
            <TableColumnDropdown
              columns={columns}
              changeColumnStatus={changeColumnStatus}
            />
            <br />
            <ButtonGroup size="small" variant="contained" className="my-3">
              <CustomGreenButton
                onClick={() => {
                  const dat = [...passwords];
                  navigator.clipboard
                    .writeText(JSON.stringify(dat))
                    .then(async () => {
                      await swal({
                        title: "Se ha copiado la tabla!",
                        icon: "success",
                      });
                    });
                }}
              >
                Copy
              </CustomGreenButton>

              <CustomGreenButton>
                <ExcelWorkBook
                  columns={columns}
                  rows={passwords}
                  filename={"Lista-Usuarios-Academia"}
                />
              </CustomGreenButton>

              <CustomGreenButton
                onClick={() => {
                  exportFromJSON({
                    data: passwords,
                    fileName: "Lista-Usuarios-Academia",
                    exportType: exportFromJSON.types.csv,
                  });
                }}
              >
                CSV
              </CustomGreenButton>
            </ButtonGroup>
            <MDBDataTable
              small
              responsive
              searchTop
              searchBottom={false}
              barReverse
              pagingTop
              striped
              bordered
              data={{
                columns: columns.filter((obj) => obj.isVisible),
                rows: passwords,
              }}
              noBottomColumns
              order={["name", "asc"]}
              entriesOptions={[5, 10, 20, 50]}
              entriesLabel="Numero de filas"
              searchLabel="Buscar"
              paginationLabel={["Anterior", "Siguiente"]}
              infoLabel={["Mostrando filas", "a", "de", "filas"]}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PasswordGenerator;
